import { render, staticRenderFns } from "./CompInformationTextImage.vue?vue&type=template&id=19b2c1e5"
import script from "./CompInformationTextImage.vue?vue&type=script&lang=js"
export * from "./CompInformationTextImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports